import React, {useEffect, useState} from 'react';
//import InArticlead from './inarticlead';

const SingleContent = ({htmlContent}) => {
    const [processedContent, setProcessedContent] = useState('');

    useEffect(() => {
        if (!htmlContent) {
            return;
        }

       // htmlContent = htmlContent.replace(/^<!--|-->$/g, '');

        function splitHTMLByTags(htmlContent) {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;

            // Convert child nodes, including comments, to an array
            return Array.from(container.childNodes);
        }

        function reassembleHTMLByTags(elements) {
            const scriptSrcs = []; // Track the script src values
            const newElements = [];

            elements.forEach((element, index) => {
                if (element instanceof Comment) {
                    // Handle comment nodes
                   // newElements.push(<React.Fragment key={index}>{element.nodeValue}</React.Fragment>);
                } else if (typeof element === 'string') {
                    // Handle text nodes
                    newElements.push(<React.Fragment key={index}>{element}</React.Fragment>);
                } else if (element instanceof HTMLElement) {
                    // Handle HTML elements
                    if (element.tagName.toLowerCase() === 'script') {
                        if (element.src) {
                            // Check if script with same src has already been appended
                            if (scriptSrcs.includes(element.src)) {
                                // Skip appending the script tag
                            } else {
                                scriptSrcs.push(element.src); // Add the src to the tracked list
                                // Create and append script tag with src
                                const scriptElement = document.createElement('script');
                                scriptElement.src = element.src;
                                document.body.appendChild(scriptElement);
                                // Don't add the script tag to the new elements
                            }
                        } else {
                            // Create and execute inline script tag
                            const scriptContent = element.innerHTML;
                            const scriptElement = document.createElement('script');
                            scriptElement.innerHTML = scriptContent;
                            document.body.appendChild(scriptElement);
                            // Don't add the script tag to the new elements
                        }
                    } else {
                        // Render other HTML elements
                        newElements.push(element.outerHTML);
                    }
                } else {
                    // Invalid element, ignore or handle error
                }
            });

            return newElements.join(''); // Filter out null values
        }

        function insertInArticleAdTags(elements) {
            //const newElements = [];
            let float = 'right';

           // elements.forEach((element, index) => {
                //newElements.push(element);

                const ptags = document.querySelectorAll("p");


               // if (element.tagName === 'P' && (index + 1) % 10 === 0) {
                    const adId = `myjoyonline_in_article_mid-200`;
                    const adSlot = '/1002554/Myjoyonline/myjoyonline_in_article_mid';
                   
                    

                    const divElement = document.createElement('div');
                    //divElement.setAttribute('class', '_feeditem');
                    divElement.setAttribute('id', adId);
                    divElement.setAttribute('style', `padding: 0px 15px 15px 0px; border: medium none; float: ${float};`);
                    float = float === 'right' ? 'left' : 'right'; // Alternate the float value

                    let scriptElement = document.createElement("script")
                    //let ud = document.getElementById(adId)
                    let txtnode = document.createTextNode("googletag.cmd.push(function() {" +
                        "var scrollslot = googletag.defineSlot('" + adSlot + "', [[300, 250]])" +
                        ".setTargeting('page', ['article']).setTargeting('refresh', 'true').setTargeting('url', ['myjoyonline.com'])" +
                        ".addService(googletag.pubads());" +

                        "var div = document.createElement('div');" +
                        "div.id = scrollslot.getSlotElementId(); document.getElementById('" + adId + "').appendChild(div);" +
                        "googletag.display(scrollslot);}); ")
                    scriptElement.appendChild(txtnode)
                    ptags[10].appendChild(scriptElement)
                   // newElements.push(divElement);
                    //newElements.push(scriptElement);
             //   }
           // });
           // return newElements;
        }

        const elements = splitHTMLByTags(htmlContent);
        //const elementsWithInArticleAdTags = insertInArticleAdTags(elements);
        const reassembledHTML = reassembleHTMLByTags(elements);

        setProcessedContent(reassembledHTML);
    }, [htmlContent]);

    return <div className="article-text" dangerouslySetInnerHTML={{__html: processedContent}}/>;
};

export default SingleContent;